
import React, { useState , useEffect} from "react";
import { loaderBar,  apibaseURl , changeDateFotmate, currencySymbol , loggedInUserDetails , loggedInCustomerDetails } from '../../functions/Function';
import  Sell  from "./Sell";
const  Portfolio = (props) => {
   const [show, setShow] = useState(false);
   const [sell, setSell] = useState({});

   const [data, setData] = useState({});
    const [isLoading, setisLoading] = useState(true);
    
    const handClickOnSell = (product) => {
      setSell(product);
      setShow(true);
    }; 

    const close = () => {
         setShow(false);
    };

    const updatePorfolioList = () => {
            fetchData();
 };
    
    

    const fetchData = () => {
      fetch(apibaseURl + "portfolioProducts/"+loggedInCustomerDetails('id'))
        .then(res => res.json())
        .then((result) => {
          if (result.result == true) {
              setisLoading(false);
              setData(result.response);
            }
        }
        )
    }
    
    useEffect(() => {
      fetchData();
   }, [])
  
  return (
    <>
         <Sell show={show} sell={sell} close={close}  updatePorfolioList={updatePorfolioList} />
        
        <div className="tab-pane fade show active" id="balance" role="tabpanel" aria-labelledby="balance-tab">
                           <div className="balance-tab-content">
                              <div className="trade-one-table-box trade-shadow-box">
                                 <table className="table table-borderless final-table mb-0 ivo-table-responsive">
                                    <thead>
                                       <tr className="trade-tablke-header">
                                          <th scope="col">Name</th>
                                          <th scope="col">Price</th>
                                          <th scope="col">Qty</th>
                                          <th scope="col">Total</th>
                                          <th scope="col">Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                    {isLoading == true && 
                                       <tr>
                                             <td colSpan={5} className="text-center data-not-found">{loaderBar(100 , 25)}</td>
                                       </tr>
                                    }
                                       {isLoading == false &&
                                       <>
                                          { Object.keys(data).length > 0  ? data.map((row, i) => (
                                          <tr className="final-table-tr">
                                             <td data-label="Name" className="final-table-heading">
                                                <div className="d-flex">
                                                   <div><span className="badge finlal-table-badge">BUY</span></div>
                                                   <div className="final-heading-left">
                                                      <h5>{row.product_name}</h5>
                                                   </div>
                                                </div>
                                             </td>
                                             <td data-label="Unit Price"><span>
                                                {currencySymbol()}
                                                {row.product_current_price}
                                                </span>
                                                </td>

                                                <td data-label="Qty"><span>
                                                {row.current_qty}
                                                </span>
                                                </td>

                                             <td data-label="Total">{currencySymbol()}

                                                {row.total_price}

                                             </td>
                                             <td data-label="Action"><button className="btn ivo-site-btn sell-btn-sm ml-2" onClick={()=>handClickOnSell(row)}> SELL </button>
                                             </td>
                                          </tr>
                                          ))
                                          : 
                                          <tr>
                                                <td colSpan={5} className="text-center data-not-found">Data Not Found</td>
                                          </tr>
                                          }
                                       </> }
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>        
    </>

  );
}

export default Portfolio;
